import React, { useEffect, useState, useRef } from "react";
import '../Styles/Home.css';
import maintitle from "../Assets/maintitle.png";
import footerLogo from "../Assets/logo.png";
import frameSlider from "../Assets/Home/frame.png";
import mobileFrameSecond from "../Assets/Home/mobileSecondFrame.png";

// Slider Videos
// 1
import BandHuntMobile from "../Assets/Video/BandHuntMobile.webm";
import BandHuntWeb from "../Assets/Video/BandHuntWeb.webm";
// 2
import MahindravideoMobile from "../Assets/Video/MahindravideoMobile.webm";
import MahindravideoWeb from "../Assets/Video/MahindravideoWeb.mp4";
// 3
import firstIntroVideo from "../Assets/Video/IrockPromoWeb.webm";
import firstIntroVideoMobile from "../Assets/Video/IrockPromoMobile.webm";
// 4
import secondIntroVideo from "../Assets/Video/iRockTeaserFinalPromo.webm";
import secondIntroVideoMobile from "../Assets/Video/iRockTeaserFinalPromoMobile.webm";
// 

// video poster
import bandHuntMobileP from "../Assets/Video/bandHuntMobile.webp";
import bandHuntWebP from "../Assets/Video/bandHuntWeb.webp";
import initialMobilePoster from "../Assets/Video/initialMobilePoster.webp";
import initialPoster from "../Assets/Video/initialposter.webp";
import posterOne from "../Assets/Video/poster.webp";
import posterOneMobile from "../Assets/Video/posterMobileFirst.webp";
import posterTwoMobile from "../Assets/Video/posterMobileSecond.webp";
import posterTwo from "../Assets/Video/posterTwo.webp";

import instagramLogo from "../Assets/Home/instagram.svg";
import facebookLogo from "../Assets/Home/facebook.svg";
import VisibilitySensor from 'react-visibility-sensor';
import { Carousel, Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Autoplay, Navigation, FreeMode } from 'swiper';
import Parikrama from "../Assets/ArtistsName/parikrama.png";
import Parvaz from "../Assets/ArtistsName/parvaaz.png";
import Thaikkudam from "../Assets/ArtistsName/thaikkudam.webp";
import AWKS from "../Assets/ArtistsName/awks.webp";
import Zero from "../Assets/ArtistsName/Zero.png";
import F16 from "../Assets/ArtistsName/f16.webp";
import Avial from "../Assets/ArtistsName/avial.webp";
import IndusCreed from "../Assets/ArtistsName/induscreed.png";
import Pentagram from "../Assets/ArtistsName/pentagram.webp";
import Bloodywood from "../Assets/ArtistsName/bloodywood.webp";
// sponsors
import tuborg from "../Assets/Home/sponsors/tuborg.svg";
import jawa from "../Assets/Home/sponsors/jawa.svg";
import mahindra from "../Assets/Home/sponsors/mahindra.png";
import pipers from "../Assets/Home/sponsors/pipers.png";
import promotedBy from "../Assets/Home/sponsors/promotedBy.svg";
import coSponsorsBy from "../Assets/Home/sponsors/coSponsorsBy.png";
import gledo from "../Assets/Home/sponsors/gledo.png";
import radioOne from "../Assets/Home/sponsors/radioOne.png";

// Import Swiper styles

SwiperCore.use([Pagination, Autoplay, Navigation, FreeMode]);


function Home() {
    const [index, setIndex] = useState(0);
    // web
    const videoRefBH = useRef(null);
    const videoRefInitial = useRef(null);
    const videoRef = useRef(null);
    const videoRef1 = useRef(null);
    // mobile
    const videoRefBHMobile = useRef(null);
    const videoRefInitialMobile = useRef(null);
    const videoRefM = useRef(null);
    const videoRef1M = useRef(null);
    // web state
    const [isVisibleBH, setIsVisibleBH] = useState(false);
    const [isVisibleInitial, setIsVisibleInitial] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleOne, setIsVisibleOne] = useState(false);
    // mobile state
    const [isVisibleBHMobile, setIsVisibleBHMobile] = useState(false);
    const [isVisibleInitialMobile, setIsVisibleInitialMobile] = useState(false);
    const [isVisibleM, setIsVisibleM] = useState(false);
    const [isVisibleOneM, setIsVisibleOneM] = useState(false);

    // web condition
    useEffect(() => {
        if (isVisibleBH) {
            videoRefBH.current.play();
        } else {
            if (videoRefBH.current.play) {
                videoRefBH.current.pause();
            }
        }
    }, [isVisibleInitial]);

    useEffect(() => {
        if (isVisibleInitial) {
            videoRefInitial.current.play();
        } else {
            if (videoRefInitial.current.play) {
                videoRefInitial.current.pause();
            }
        }
    }, [isVisibleInitial]);

    useEffect(() => {
        if (isVisible) {
            videoRef.current.play();
        } else {
            if (videoRef.current.play) {
                videoRef.current.pause();
            }
        }
    }, [isVisible]);

    useEffect(() => {
        if (isVisibleOne) {
            videoRef1.current.play();
        } else {
            if (videoRef1.current.play) {
                videoRef1.current.pause();
            }
        }
    }, [isVisibleOne]);

    // mobile condition

    useEffect(() => {
        if (isVisibleBHMobile) {
            videoRefBHMobile.current.play();
        } else {
            if (videoRefBHMobile.current.play) {
                videoRefBHMobile.current.pause();
            }
        }
    }, [isVisibleBHMobile]);

    useEffect(() => {
        if (isVisibleInitialMobile) {
            videoRefInitialMobile.current.play();
        } else {
            if (videoRefInitialMobile.current.play) {
                videoRefInitialMobile.current.pause();
            }
        }
    }, [isVisibleInitialMobile]);

    useEffect(() => {
        if (isVisibleM) {
            videoRefM.current.play();
        } else {
            if (videoRefM.current.play) {
                videoRefM.current.pause();
            }
        }
    }, [isVisibleM]);

    useEffect(() => {
        if (isVisibleOneM) {
            videoRef1M.current.play();
        } else {
            if (videoRef1M.current.play) {
                videoRef1M.current.pause();
            }
        }
    }, [isVisibleOneM]);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };
    return (
        <div>
            <section className='first_fold'>

                <div className="desktopView">
                    <Carousel className="customSliderTop" interval={null}>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameNew' src={frameSlider} alt="iRock Frame"></img>
                                <div className="overlay">
                                    <VisibilitySensor onChange={(isVisibleBH) => setIsVisibleBH(isVisibleBH)}>
                                        <video style={{ width: '89%', borderRadius: "8px" }} ref={videoRefBH} controls poster={bandHuntWebP}>
                                            <source src={BandHuntWeb} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>

                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameNew' src={frameSlider} alt="iRock Frame"></img>
                                <div className="overlay">
                                    <VisibilitySensor onChange={(isVisible) => setIsVisible(isVisible)}>
                                        <video style={{ width: '89%', borderRadius: "8px" }} ref={videoRef} controls poster={posterOne}>
                                            <source src={firstIntroVideo} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>

                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameNew' src={frameSlider} alt="iRock Frame"></img>
                                <div className="overlay">
                                    <VisibilitySensor onChange={(isVisibleInitial) => setIsVisibleInitial(isVisibleInitial)}>
                                        <video autoPlay style={{ width: '89%', borderRadius: "8px" }} ref={videoRefInitial} controls poster={initialPoster}>
                                            <source src={MahindravideoWeb} type="video/mp4"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameNew' src={frameSlider} alt="iRock Frame"></img>
                                <div className="overlay">
                                    <VisibilitySensor onChange={(isVisibleOne) => setIsVisibleOne(isVisibleOne)}>
                                        <video style={{ width: '89%', borderRadius: "8px" }} ref={videoRef1} poster={posterTwo} controls>
                                            <source src={secondIntroVideo} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="mobileView">
                    <Carousel className="customSliderTop" interval={null}>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className="overlayMobile">
                                    <VisibilitySensor onChange={(isVisibleBHMobile) => setIsVisibleBHMobile(isVisibleBHMobile)}>
                                        <video style={{ width: '83%', borderRadius: "8px" }} poster={bandHuntMobileP} controls ref={videoRefBHMobile}>
                                            <source src={BandHuntMobile} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className="overlayMobile">
                                    <VisibilitySensor onChange={(isVisibleM) => setIsVisibleM(isVisibleM)}>
                                        <video style={{ width: '83%', borderRadius: "8px" }} poster={posterOneMobile} controls ref={videoRefM}>
                                            <source src={firstIntroVideoMobile} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className="overlayMobile">
                                    <VisibilitySensor onChange={(videoRefInitialMobile) => setIsVisibleInitialMobile(videoRefInitialMobile)}>
                                        <video autoPlay style={{ width: '83%', borderRadius: "8px" }} poster={initialMobilePoster} controls ref={videoRefInitialMobile}>
                                            <source src={MahindravideoMobile} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="containerr">
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className="overlayMobile">
                                    <VisibilitySensor onChange={(isVisibleOneM) => setIsVisibleOneM(isVisibleOneM)}>
                                        <video style={{ width: '83%', borderRadius: "8px" }} poster={posterTwoMobile} controls ref={videoRef1M}>
                                            <source src={secondIntroVideoMobile} type="video/webm"></source>
                                        </video>
                                    </VisibilitySensor>
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </div>
                <Carousel className="customSlider" fade>
                    <Carousel.Item>
                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='relative_frames'>
                            <img className='imgFrame' src={frameSlider} alt="iRock Frame"></img>
                            <div className='content_slider'>
                                <h1 className='caption_slider_first'>
                                    Independence Rock <br></br>
                                    Where it all began  <br></br>
                                    November 5-6  <br></br>
                                    It’s back.  <br></br>
                                </h1>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='relative_frames'>
                            <img className='imgFrame' src={frameSlider} alt="iRock Frame"></img>
                            <div className='content_slider'>
                                <h2 className='caption_slider'>The best of Indian  rock and metal under one loud roof, since 1986.
                                    I-Rock is a celebration of the spirit of rock, and it’s now back - bigger, louder, prouder.</h2>
                                <div className="space_top">
                                    <a className="butttonSlider" rel="noopener noreferrer" href="https://go.insider.in/3cIejc2" target="_blank">Get your tickets now</a>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </section>
            <section className="second_fold">
                <div data-aos="zoom-in-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='title'>
                    <img className='title_irock zoom-in-zoom-out' src={maintitle} alt="iRock logo"></img>
                </div>
            </section>
            <section className='info_block desktopView'>
                <div data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className="second_slider">
                    <Carousel className="customSliderSecond">
                        <Carousel.Item>
                            <div className='relative_frames'>
                                <img className='imgFrameSecond' src={frameSlider} alt="iRock Frame"></img>
                                <div className='content_slider_second'>
                                    <h2 className='irock_head'>I-Rock 2022</h2>
                                    <p className='about_para'>I-Rock has quite a history. It launched bands. It created legends. It defied the authorities. It shaped the music of many generations. And now, it’s back in a whole new avatar, ready to do its thing once again.
                                        <br></br>
                                        <br></br>
                                        From saluting yesterday's headliners to giving a stage to tomorrow's
                                        <br></br>
                                        Welcome to Independence Rock 2022</p>

                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className='relative_frames'>
                                <img className='imgFrameSecond' src={frameSlider} alt="iRock Frame"></img>
                                <div className='content_slider_second'>
                                    <h2 className='irock_head center_txt'>Venue & Schedule</h2>
                                    <p className='about_para center_txt'>I-Rock has a new home.</p>

                                    <p className='about_para center_txt'>Get ready to rock at Mazgaon Docks.</p>
                                    <p className='about_para center_txt'>See you on November 5-6, 2022</p>
                                    <div className="space_top">
                                        <a className="butttonSlider" rel="noopener noreferrer" href="https://maps.app.goo.gl/jDH3vrTRzZXnXq2w8" target="_blank">View Location</a>
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </section>
            <section className='info_block mobileView'>
                <div className="second_slider">
                    <Carousel className="customSliderSecond">
                        <Carousel.Item>
                            <div className='relative_frames'>
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className='content_slider_second'>
                                    <h2 className='irock_head'>I-Rock 2022</h2>
                                    <p className='about_para'>The best of Indian rock and metal under one loud roof, since 1986.
                                        <br></br>
                                        <br></br>
                                        I-Rock is a celebration of the spirit of rock, and it’s now back - bigger, louder, prouder.
                                        From saluting yesterday's headliners to giving a stage to tomorrow's...
                                        <br></br>
                                        <br></br>
                                        <span className='size_increase'>Welcome to Independence Rock 2022</span>
                                    </p>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className='relative_frames'>
                                <img className='imgFrameSecond' src={mobileFrameSecond} alt="iRock Frame"></img>
                                <div className='content_slider_second'>
                                    <h2 className='irock_head center_txt'>Venue & Schedule</h2>
                                    <p className='about_para center_txt'>I-Rock has a new home.</p>

                                    <p className='about_para center_txt'>Get ready to rock at Mazgaon Docks.</p>
                                    <p className='about_para center_txt'>See you on November 5-6, 2022</p>
                                    <div className="space_top">
                                        <a className="butttonSlider" rel="noopener noreferrer" href="https://maps.app.goo.gl/jDH3vrTRzZXnXq2w8" target="_blank">View Location</a>
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </section>


            {/* Line Up block starts */}
            {/* <section className='fifth_fold'>
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-easing="ease-in" className='relative_frames'>
                    <img className='imgFrame' src={frameProps}></img>
                    <div className='content_Div'>
                        <h3 data-aos="flip-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='irock_head sizeA'>Line-Up</h3>
                        <img className='artistTitle' src={TitleArtist}></img>
                        <div className="space_top">
                            <a className="butttonSlider" rel="noopener noreferrer" href="/lineup">Know More</a>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="lineUpSection">
                <div className='content_social'>
                    <h3 data-aos="flip-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='lineUpHead center_txt'>Line Up</h3>
                </div>
                <div className="sliderLineUp">
                    <Swiper
                        spaceBetween={30}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }}
                        loop={true}
                        navigation={true}
                        autoplay={true}
                        modules={[Pagination, Navigation, FreeMode, Autoplay]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <img className="sliderArtist" src={Parikrama} alt="parikrama"></img>
                            <h2 className='artistNameMain center'>Parikrama</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Parvaz} alt="parvaz"></img>
                            <h2 className='artistNameMain center'>Parvaz</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Thaikkudam} alt="Thaikkudam"></img>
                            <h2 className='artistNameMain center' >Thaikkudam Bridge</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={AWKS} alt="Aswekeepsearching"></img>
                            <h2 className='artistNameMain center'>Aswekeepsearching</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Zero} alt="Zero"></img>
                            <h2 className='artistNameMain center' >Zero</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={F16} alt="The F16s"></img>
                            <h2 className='artistNameMain center'>The F16s</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Avial} alt="Avial"></img>
                            <h2 className='artistNameMain center'>Avial</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={IndusCreed} alt="Indus Creed"></img>
                            <h2 className='artistNameMain center'>Indus Creed</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Pentagram} alt="Pentagram"></img>
                            <h2 className='artistNameMain center'>Pentagram</h2>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="sliderArtist" src={Bloodywood} alt="Bloodywood"></img>
                            <h2 className='artistNameMain center'>Bloodywood</h2>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="space_top">
                    <a className="butttonSlider" rel="noopener noreferrer" href="/lineup">Know More</a>
                </div>
            </section>
            {/* Line Up block ends */}
            {/* social plugin */}
            <section id='#custom' className='insta_plugin'>
                <div className='content_social'>
                    <h3 data-aos="flip-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='main_head'>Rockin' the 'gram <a href='https://www.instagram.com/independencerock/' target="_blank" rel="noopener noreferrer" className='style_social'>@independencerock</a></h3>
                </div>
                <Container fluid className="mlr_space">
                    <div className="elfsight-app-4737a970-2d8b-49db-8af3-e808f683c813"></div>
                </Container>
            </section>
            {/* sponsors */}
            <section className="sponsorsBlock">
                <div className='content_social'>
                    <h3 data-aos="flip-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='lineUpHead center_txt'>Our Sponsor's</h3>
                </div>
                <div className="imgBlockSponsors">
                    <div className="spaceRightSponsors">
                        <p className="sponsorstag">Title Partner</p>
                        <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={mahindra} alt="Mahindra - iRock" className="sponsorsLogo"></img>

                    </div>
                    <div className="spaceRightSponsors">
                        <p className="sponsorstag">Powered By</p>
                        <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={pipers} alt="100 pipers - iRock" className="sponsorsLogo"></img>

                    </div>
                    <div className="spaceRightSponsors">
                        <p className="sponsorstag">Ride Partner</p>
                        <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={jawa} alt="jawa - iRock" className="sponsorsLogo"></img>

                    </div>
                </div>

                <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={coSponsorsBy} className="coSponsorsByImg" alt="thumbs up, tuborg" />
                <br></br>
                <div className="imgBlockSponsors">
                    <div className="spaceRightSponsors">
                        <p className="sponsorstag">Outdoor Partner</p>
                        <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={gledo} alt="gledo - iRock" className="sponsorsLogo"></img>

                    </div>
                    <div className="spaceRightSponsors">
                        <p className="sponsorstag">Radio Partner</p>
                        <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={radioOne} alt="radioOne - iRock" className="sponsorsLogo"></img>

                    </div>
                </div>
                <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" src={promotedBy} className="promotedByImg" alt="hyperlink, paytminsider, farhad wadia" />
            </section>
            <section className='footer_block'>
                <div data-aos="zoom-in-up" data-aos-duration="2000" data-aos-easing="ease-in-out" className='footer_content'>
                    <img src={footerLogo} className="fluid_img footer_img" alt="iRock logo"></img>
                    <p className='footer_txt'>Got questions?</p>
                    <p className='footer_txt_body'>Write to us at
                    </p>
                    <a href="mailto:rocknroll@independecerock.in" rel="noreferrer" className='footer_link_mail'> rocknroll@independecerock.in</a>
                    <br></br><br></br>
                    <p className='footer_txt'>And check us out at</p>
                    <div>
                        <a href="https://www.instagram.com/independencerock/" rel="noopener noreferrer" target="_blank">
                            <img className="socialStyle" src={instagramLogo} alt="iRock instagram logo"></img>
                        </a>
                        <a href="https://www.facebook.com/independencerock/?ref=page_internal" rel="noopener noreferrer" target="_blank">
                            <img className="socialStyle" src={facebookLogo} alt="iRock facebook logo"></img>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home